<template>
	<div class="about">
    <p class="about-tit">关于我们</p>
    <div class="content">深圳市橙子互动科技有限公司成立于2016年11月，位于深圳市南山区软件产业基地，公司致力于打造年轻化的娱乐社交产品，主打产品为“处CP”APP，2017年6月上线以来已发展为千万级应用，目前正处于稳步向前发展中。</div>
		<p class="about-tit">联系我们</p>
		<div class="content">
			<p>公司电话：0755-26913501</p>
			<p>公司地址：广东省深圳市南山区科园路2002号卫星大厦1709</p>
			<p>客服QQ公众号：800800664</p>
			<p>处CP官方QQ2群：319696780</p>
			<p>处CP官方QQ3群：829479064</p>
      <p>客服邮箱：service@chucp.mobi</p>
		</div>
		<div class="map-img">
			<img src="../assets/map.png" alt="">
		</div>
	</div>
</template>
<script>
	export default {
		name: 'about',
		data (){
			return {

			}
		},
    created:function() {
      this.$store.commit('inWhichPage',{page:'isAbout'});
    }
	}
</script>

<style scoped>
  .about{
    min-width: 935px;
    width: 935px;
    margin: 0 auto;
    margin-top: 120px;
    margin-bottom: 40px;
		display: inline-block;
  }
	.about-tit{
    font-size: 22px;
    color: #232323;
    text-align: left;
    margin-bottom: 25px;
  }
  .content{
    width: 100%;
    box-sizing: border-box;
    padding: 2.1%  3%;
    background: #F7F7F9;
    text-align: left;
    font-size: 14px;
    color: #232323;
    letter-spacing: 0;
    line-height: 24px;
		border-radius: 8px;
		margin-bottom: 60px;
  }
	.map-img img{
		width: 935px;
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/page/about.vue